var React = require('react');

function BgArrowPointerBottomRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#c1c9d2","d":"M1012.093,833.573,0,444.231V422H1366V729L1096.575,833.518c-11.554,4.493-26.9,6.648-42.063,6.471q-.9.012-1.8.011C1037.965,840,1023.253,837.9,1012.093,833.573Z","transform":"translate(0 -422)"}));
}

BgArrowPointerBottomRightInline.defaultProps = {"width":"1366","height":"418","viewBox":"0 0 1366 418"};

module.exports = BgArrowPointerBottomRightInline;

BgArrowPointerBottomRightInline.default = BgArrowPointerBottomRightInline;
